/* eslint-disable @typescript-eslint/no-var-requires */
const { doggyDayCareService, homeDogBoardingService, dogSittingService, petSittingService } = require('./Service');

const {
    EnglishBelgium,
    GermanBelgium,
    FrenchBelgium,
    DutchBelgium,
    EnglishSwitzerland,
    GermanSwitzerland,
    FrenchSwitzerland,
    ItalianSwitzerland,
    GermanLuxembourg,
    FrenchLuxembourg,
    EnglishLuxembourg,
    FrenchCanada,
    EnglishCanada,
    EnglishGermany,
    EnglishFrance,
    FrenchFrance,
    EnglishNetherlands,
    DutchNetherlands,
    GermanAustria,
    EnglishAustria,
    EnglishNewZealand,
    EnglishGreatBritain,
    EnglishAustralia,
    EnglishHongKong,
    EnglishSingapore,
    GermanGermany,
    DanishDenmark,
    EnglishDenmark,
    FinnishFinland,
    EnglishFinland,
    EnglishIreland,
    ItalianItaly,
    EnglishItaly,
    EnglishJapan,
    NorwegianNorway,
    EnglishNorway,
    SwedishSweden,
    EnglishSweden,
    EnglishUnitedStates,
} = require('./Locale/Locale');

const httpsDePawshakeCh = 'https://de.pawshake.ch';
const httpsFrPawshakeCh = 'https://fr.pawshake.ch';
const httpsItPawshakeCh = 'https://it.pawshake.ch';
const httpsEnPawshakeLu = 'https://en.pawshake.lu';
const httpsDePawshakeLu = 'https://de.pawshake.lu';
const httpsFrPawshakeLu = 'https://fr.pawshake.lu';
const httpsEnPawshakeBe = 'https://en.pawshake.be';
const httpsDePawshakeBe = 'https://de.pawshake.be';
const httpsNlPawshakeBe = 'https://nl.pawshake.be';
const httpsFrPawshakeBe = 'https://fr.pawshake.be';
const httpsEnBeStagingPawshakeIo = 'https://en-be.staging-pawshake.io';
const httpsNlBeStagingPawshakeIo = 'https://nl-be.staging-pawshake.io';
const httpsFrBeStagingPawshakeIo = 'https://fr-be.staging-pawshake.io';
const httpsDeBeStagingPawshakeIo = 'https://de-be.staging-pawshake.io';
const httpsDeChStagingPawshakeIo = 'https://de-ch.staging-pawshake.io';
const httpsFrChStagingPawshakeIo = 'https://fr-ch.staging-pawshake.io';
const httpsItChStagingPawshakeIo = 'https://it-ch.staging-pawshake.io';
const httpsEnLuStagingPawshakeIo = 'https://en-lu.staging-pawshake.io';
const httpsDeLuStagingPawshakeIo = 'https://de-lu.staging-pawshake.io';
const httpsFrLuStagingPawshakeIo = 'https://fr-lu.staging-pawshake.io';
const httpsEnCaStagingPawshakeIo = 'https://en-ca.staging-pawshake.io';
const httpsFrCaStagingPawshakeIo = 'https://fr-ca.staging-pawshake.io';
const httpsEnDeStagingPawshakeIo = 'https://en-de.staging-pawshake.io';
const httpsDeDeStagingPawshakeIo = 'https://de-de.staging-pawshake.io';
const httpsEnFrStagingPawshakeIo = 'https://en-fr.staging-pawshake.io';
const httpsFrFrStagingPawshakeIo = 'https://fr-fr.staging-pawshake.io';
const httpsEnNlStagingPawshakeIo = 'https://en-nl.staging-pawshake.io';
const httpsNlNlStagingPawshakeIo = 'https://nl-nl.staging-pawshake.io';
const httpsDeAtStagingPawshakeIo = 'https://de-at.staging-pawshake.io';
const httpsEnAtStagingPawshakeIo = 'https://en-at.staging-pawshake.io';
const httpsEnNzStagingPawshakeIo = 'https://en-nz.staging-pawshake.io';
const httpsEnGbStagingPawshakeIo = 'https://en-gb.staging-pawshake.io';
const httpsEnAuStagingPawshakeIo = 'https://en-au.staging-pawshake.io';
const httpsEnHkStagingPawshakeIo = 'https://en-hk.staging-pawshake.io';
const httpsEnSgStagingPawshakeIo = 'https://en-sg.staging-pawshake.io';
const httpsDaDkStagingPawshakeIo = 'https://da-dk.staging-pawshake.io';
const httpsEnDkStagingPawshakeIo = 'https://en-dk.staging-pawshake.io';
const httpsFiFiStagingPawshakeIo = 'https://fi-fi.staging-pawshake.io';
const httpsEnFiStagingPawshakeIo = 'https://en-fi.staging-pawshake.io';
const httpsEnIeStagingPawshakeIo = 'https://en-ie.staging-pawshake.io';
const httpsItItStagingPawshakeIo = 'https://it-it.staging-pawshake.io';
const httpsEnItStagingPawshakeIo = 'https://en-it.staging-pawshake.io';
const httpsEnJpStagingPawshakeIo = 'https://en-jp.staging-pawshake.io';
const httpsNoNoStagingPawshakeIo = 'https://no-no.staging-pawshake.io';
const httpsEnNoStagingPawshakeIo = 'https://en-no.staging-pawshake.io';
const httpsSvSeStagingPawshakeIo = 'https://sv-se.staging-pawshake.io';
const httpsEnSeStagingPawshakeIo = 'https://en-se.staging-pawshake.io';
const httpsEnChStagingPawshakeIo = 'https://en-ch.staging-pawshake.io';
const httpsEnUsStagingPawshakeIo = 'https://en-us.staging-pawshake.io';
const httpsEnBePawshakeMe = 'https://en-be.pawshake.me';
const httpsNlBePawshakeMe = 'https://nl-be.pawshake.me';
const httpsFrBePawshakeMe = 'https://fr-be.pawshake.me';
const httpsDeBePawshakeMe = 'https://de-be.pawshake.me';
const httpsDeChPawshakeMe = 'https://de-ch.pawshake.me';
const httpsFrChPawshakeMe = 'https://fr-ch.pawshake.me';
const httpsItChPawshakeMe = 'https://it-ch.pawshake.me';
const httpsEnLuPawshakeMe = 'https://en-lu.pawshake.me';
const httpsDeLuPawshakeMe = 'https://de-lu.pawshake.me';
const httpsFrLuPawshakeMe = 'https://fr-lu.pawshake.me';
const httpsEnCaPawshakeMe = 'https://en-ca.pawshake.me';
const httpsFrCaPawshakeMe = 'https://fr-ca.pawshake.me';
const httpsEnDePawshakeMe = 'https://en-de.pawshake.me';
const httpsDeDePawshakeMe = 'https://de-de.pawshake.me';
const httpsEnFrPawshakeMe = 'https://en-fr.pawshake.me';
const httpsFrFrPawshakeMe = 'https://fr-fr.pawshake.me';
const httpsEnNlPawshakeMe = 'https://en-nl.pawshake.me';
const httpsNlNlPawshakeMe = 'https://nl-nl.pawshake.me';
const httpsDeAtPawshakeMe = 'https://de-at.pawshake.me';
const httpsEnAtPawshakeMe = 'https://en-at.pawshake.me';
const httpsEnNzPawshakeMe = 'https://en-nz.pawshake.me';
const httpsEnGbPawshakeMe = 'https://en-gb.pawshake.me';
const httpsEnAuPawshakeMe = 'https://en-au.pawshake.me';
const httpsEnHkPawshakeMe = 'https://en-hk.pawshake.me';
const httpsEnSgPawshakeMe = 'https://en-sg.pawshake.me';
const httpsDaDkPawshakeMe = 'https://da-dk.pawshake.me';
const httpsEnDkPawshakeMe = 'https://en-dk.pawshake.me';
const httpsFiFiPawshakeMe = 'https://fi-fi.pawshake.me';
const httpsEnFiPawshakeMe = 'https://en-fi.pawshake.me';
const httpsEnIePawshakeMe = 'https://en-ie.pawshake.me';
const httpsItItPawshakeMe = 'https://it-it.pawshake.me';
const httpsEnItPawshakeMe = 'https://en-it.pawshake.me';
const httpsEnJpPawshakeMe = 'https://en-jp.pawshake.me';
const httpsNoNoPawshakeMe = 'https://no-no.pawshake.me';
const httpsEnNoPawshakeMe = 'https://en-no.pawshake.me';
const httpsSvSePawshakeMe = 'https://sv-se.pawshake.me';
const httpsEnSePawshakeMe = 'https://en-se.pawshake.me';
const httpsEnChPawshakeMe = 'https://en-ch.pawshake.me';
const httpsEnUsPawshakeMe = 'https://en-us.pawshake.me';
const httpsEnPawshakeCa = 'https://en.pawshake.ca';
const httpsFrPawshakeCa = 'https://fr.pawshake.ca';
const httpsEnPawshakeDe = 'https://en.pawshake.de';
const httpsWwwPawshakeDe = 'https://www.pawshake.de';
const httpsEnPawshakeFr = 'https://en.pawshake.fr';
const httpsWwwPawshakeFr = 'https://www.pawshake.fr';
const httpsEnPawshakeNl = 'https://en.pawshake.nl';
const httpsWwwPawshakeNl = 'https://www.pawshake.nl';
const httpsWwwPawshakeAt = 'https://www.pawshake.at';
const httpsEnPawshakeAt = 'https://en.pawshake.at';
const httpsWwwPawshakeCoNz = 'https://www.pawshake.co.nz';
const httpsWwwPawshakeCoUk = 'https://www.pawshake.co.uk';
const httpsWwwPawshakeCom = 'https://www.pawshake.com';
const httpsWwwPawshakeComAu = 'https://www.pawshake.com.au';
const httpsWwwPawshakeComHk = 'https://www.pawshake.com.hk';
const httpsWwwPawshakeComSg = 'https://www.pawshake.com.sg';
const httpsWwwPawshakeDk = 'https://www.pawshake.dk';
const httpsEnPawshakeDk = 'https://en.pawshake.dk';
const httpsWwwPawshakeFi = 'https://www.pawshake.fi';
const httpsEnPawshakeFi = 'https://en.pawshake.fi';
const httpsWwwPawshakeIe = 'https://www.pawshake.ie';
const httpsWwwPawshakeIt = 'https://www.pawshake.it';
const httpsEnPawshakeIt = 'https://en.pawshake.it';
const httpsWwwPawshakeJp = 'https://www.pawshake.jp';
const httpsWwwPawshakeNo = 'https://www.pawshake.no';
const httpsEnPawshakeNo = 'https://en.pawshake.no';
const httpsWwwPawshakeSe = 'https://www.pawshake.se';
const httpsEnPawshakeSe = 'https://en.pawshake.se';
const httpsEnPawshakeCh = 'https://en.pawshake.ch';

const localBrandNames = {
    'https://en.pawshake.be': 'Pawshake.be',
    'https://de.pawshake.be': 'Pawshake.be',
    'https://nl.pawshake.be': 'Pawshake.be',
    'https://fr.pawshake.be': 'Pawshake.be',
    'https://en-be.staging-pawshake.io': 'Pawshake.be',
    'https://nl-be.staging-pawshake.io': 'Pawshake.be',
    'https://fr-be.staging-pawshake.io': 'Pawshake.be',
    'https://de-be.staging-pawshake.io': 'Pawshake.be',
    [httpsDeChStagingPawshakeIo]: 'Pawshake.ch',
    [httpsFrChStagingPawshakeIo]: 'Pawshake.ch',
    [httpsItChStagingPawshakeIo]: 'Pawshake.ch',
    [httpsEnLuStagingPawshakeIo]: 'Pawshake.lu',
    [httpsDeLuStagingPawshakeIo]: 'Pawshake.lu',
    [httpsFrLuStagingPawshakeIo]: 'Pawshake.lu',
    [httpsEnCaStagingPawshakeIo]: 'Pawshake.ca',
    [httpsFrCaStagingPawshakeIo]: 'Pawshake.ca',
    [httpsEnDeStagingPawshakeIo]: 'Pawshake.de',
    [httpsDeDeStagingPawshakeIo]: 'Pawshake.de',
    [httpsEnFrStagingPawshakeIo]: 'Pawshake.fr',
    [httpsFrFrStagingPawshakeIo]: 'Pawshake.fr',
    [httpsEnNlStagingPawshakeIo]: 'Pawshake.nl',
    [httpsNlNlStagingPawshakeIo]: 'Pawshake.nl',
    [httpsDeAtStagingPawshakeIo]: 'Pawshake.at',
    [httpsEnAtStagingPawshakeIo]: 'Pawshake.at',
    [httpsEnNzStagingPawshakeIo]: 'Pawshake.co.nz',
    [httpsEnGbStagingPawshakeIo]: 'Pawshake.co.uk',
    [httpsEnAuStagingPawshakeIo]: 'Pawshake.com.au',
    [httpsEnHkStagingPawshakeIo]: 'Pawshake.com.hk',
    [httpsEnSgStagingPawshakeIo]: 'Pawshake.com.sg',
    [httpsDaDkStagingPawshakeIo]: 'Pawshake.dk',
    [httpsEnDkStagingPawshakeIo]: 'Pawshake.dk',
    [httpsFiFiStagingPawshakeIo]: 'Pawshake.fi',
    [httpsEnFiStagingPawshakeIo]: 'Pawshake.fi',
    [httpsEnIeStagingPawshakeIo]: 'Pawshake.ie',
    [httpsItItStagingPawshakeIo]: 'Pawshake.it',
    [httpsEnItStagingPawshakeIo]: 'Pawshake.it',
    [httpsEnJpStagingPawshakeIo]: 'Pawshake.jp',
    [httpsNoNoStagingPawshakeIo]: 'Pawshake.no',
    [httpsEnNoStagingPawshakeIo]: 'Pawshake.no',
    [httpsSvSeStagingPawshakeIo]: 'Pawshake.se',
    [httpsEnSeStagingPawshakeIo]: 'Pawshake.se',
    [httpsEnChStagingPawshakeIo]: 'Pawshake.ch',
    [httpsEnUsStagingPawshakeIo]: 'Pawshake US',
    [httpsWwwPawshakeCom]: 'Pawshake US',
    [httpsEnBePawshakeMe]: 'Pawshake.be',
    [httpsNlBePawshakeMe]: 'Pawshake.be',
    [httpsFrBePawshakeMe]: 'Pawshake.be',
    [httpsDeBePawshakeMe]: 'Pawshake.be',
    [httpsDeChPawshakeMe]: 'Pawshake.ch',
    [httpsFrChPawshakeMe]: 'Pawshake.ch',
    [httpsItChPawshakeMe]: 'Pawshake.ch',
    [httpsEnLuPawshakeMe]: 'Pawshake.lu',
    [httpsDeLuPawshakeMe]: 'Pawshake.lu',
    [httpsFrLuPawshakeMe]: 'Pawshake.lu',
    [httpsEnCaPawshakeMe]: 'Pawshake.ca',
    [httpsFrCaPawshakeMe]: 'Pawshake.ca',
    [httpsEnDePawshakeMe]: 'Pawshake.de',
    [httpsDeDePawshakeMe]: 'Pawshake.de',
    [httpsEnFrPawshakeMe]: 'Pawshake.fr',
    [httpsFrFrPawshakeMe]: 'Pawshake.fr',
    [httpsEnNlPawshakeMe]: 'Pawshake.nl',
    [httpsNlNlPawshakeMe]: 'Pawshake.nl',
    [httpsDeAtPawshakeMe]: 'Pawshake.at',
    [httpsEnAtPawshakeMe]: 'Pawshake.at',
    [httpsEnNzPawshakeMe]: 'Pawshake.co.nz',
    [httpsEnGbPawshakeMe]: 'Pawshake.co.uk',
    [httpsEnAuPawshakeMe]: 'Pawshake.com.au',
    [httpsEnHkPawshakeMe]: 'Pawshake.com.hk',
    [httpsEnSgPawshakeMe]: 'Pawshake.com.sg',
    [httpsDaDkPawshakeMe]: 'Pawshake.dk',
    [httpsEnDkPawshakeMe]: 'Pawshake.dk',
    [httpsFiFiPawshakeMe]: 'Pawshake.fi',
    [httpsEnFiPawshakeMe]: 'Pawshake.fi',
    [httpsEnIePawshakeMe]: 'Pawshake.ie',
    [httpsItItPawshakeMe]: 'Pawshake.it',
    [httpsEnItPawshakeMe]: 'Pawshake.it',
    [httpsEnJpPawshakeMe]: 'Pawshake.jp',
    [httpsNoNoPawshakeMe]: 'Pawshake.no',
    [httpsEnNoPawshakeMe]: 'Pawshake.no',
    [httpsSvSePawshakeMe]: 'Pawshake.se',
    [httpsEnSePawshakeMe]: 'Pawshake.se',
    [httpsEnChPawshakeMe]: 'Pawshake.ch',
    [httpsEnUsPawshakeMe]: 'Pawshake US',
    'https://de.pawshake.ch': 'Pawshake.ch',
    'https://fr.pawshake.ch': 'Pawshake.ch',
    'https://it.pawshake.ch': 'Pawshake.ch',
    'https://en.pawshake.lu': 'Pawshake.lu',
    'https://fr.pawshake.lu': 'Pawshake.lu',
    'https://de.pawshake.lu': 'Pawshake.lu',
    'https://en.pawshake.ca': 'Pawshake.ca',
    'https://fr.pawshake.ca': 'Pawshake.ca',
    'https://en.pawshake.fr': 'Pawshake.fr',
    'https://www.pawshake.fr': 'Pawshake.fr',
    'https://en.pawshake.nl': 'Pawshake.nl',
    'https://www.pawshake.nl': 'Pawshake.nl',
    'https://www.pawshake.at': 'Pawshake.at',
    'https://en.pawshake.at': 'Pawshake.at',
    'https://www.pawshake.co.nz': 'Pawshake.co.nz',
    'https://www.pawshake.co.uk': 'Pawshake.co.uk',
    'https://www.pawshake.com.au': 'Pawshake.com.au',
    'https://www.pawshake.com.hk': 'Pawshake.com.hk',
    'https://www.pawshake.com.sg': 'Pawshake.com.sg',
    'https://en.pawshake.de': 'Pawshake.de',
    'https://www.pawshake.de': 'Pawshake.de',
    'https://www.pawshake.dk': 'Pawshake.dk',
    'https://en.pawshake.dk': 'Pawshake.dk',
    'https://www.pawshake.fi': 'Pawshake.fi',
    'https://en.pawshake.fi': 'Pawshake.fi',
    'https://www.pawshake.ie': 'Pawshake.ie',
    'https://www.pawshake.it': 'Pawshake.it',
    'https://en.pawshake.it': 'Pawshake.it',
    'https://www.pawshake.jp': 'Pawshake.jp',
    'https://www.pawshake.no': 'Pawshake.no',
    'https://en.pawshake.no': 'Pawshake.no',
    'https://www.pawshake.se': 'Pawshake.se',
    'https://en.pawshake.se': 'Pawshake.se',
    'https://en.pawshake.ch': 'Pawshake.ch',
};

const locales = {
    'https://en.pawshake.be': EnglishBelgium,
    'https://de.pawshake.be': GermanBelgium,
    'https://fr.pawshake.be': FrenchBelgium,
    'https://nl.pawshake.be': DutchBelgium,
    'https://en-be.staging-pawshake.io': EnglishBelgium,
    'https://nl-be.staging-pawshake.io': DutchBelgium,
    'https://fr-be.staging-pawshake.io': FrenchBelgium,
    'https://de-be.staging-pawshake.io': GermanBelgium,
    [httpsDeChStagingPawshakeIo]: GermanSwitzerland,
    [httpsFrChStagingPawshakeIo]: FrenchSwitzerland,
    [httpsItChStagingPawshakeIo]: ItalianSwitzerland,
    [httpsEnLuStagingPawshakeIo]: EnglishLuxembourg,
    [httpsDeLuStagingPawshakeIo]: GermanLuxembourg,
    [httpsFrLuStagingPawshakeIo]: FrenchLuxembourg,
    [httpsEnCaStagingPawshakeIo]: EnglishCanada,
    [httpsFrCaStagingPawshakeIo]: FrenchCanada,
    [httpsEnDeStagingPawshakeIo]: EnglishGermany,
    [httpsDeDeStagingPawshakeIo]: GermanGermany,
    [httpsEnFrStagingPawshakeIo]: EnglishFrance,
    [httpsFrFrStagingPawshakeIo]: FrenchFrance,
    [httpsEnNlStagingPawshakeIo]: EnglishNetherlands,
    [httpsNlNlStagingPawshakeIo]: DutchNetherlands,
    [httpsDeAtStagingPawshakeIo]: GermanAustria,
    [httpsEnAtStagingPawshakeIo]: EnglishAustria,
    [httpsEnNzStagingPawshakeIo]: EnglishNewZealand,
    [httpsEnGbStagingPawshakeIo]: EnglishGreatBritain,
    [httpsEnAuStagingPawshakeIo]: EnglishAustralia,
    [httpsEnHkStagingPawshakeIo]: EnglishHongKong,
    [httpsEnSgStagingPawshakeIo]: EnglishSingapore,
    [httpsDaDkStagingPawshakeIo]: DanishDenmark,
    [httpsEnDkStagingPawshakeIo]: EnglishDenmark,
    [httpsFiFiStagingPawshakeIo]: FinnishFinland,
    [httpsEnFiStagingPawshakeIo]: EnglishFinland,
    [httpsEnIeStagingPawshakeIo]: EnglishIreland,
    [httpsItItStagingPawshakeIo]: ItalianItaly,
    [httpsEnItStagingPawshakeIo]: EnglishItaly,
    [httpsEnJpStagingPawshakeIo]: EnglishJapan,
    [httpsNoNoStagingPawshakeIo]: NorwegianNorway,
    [httpsEnNoStagingPawshakeIo]: EnglishNorway,
    [httpsSvSeStagingPawshakeIo]: SwedishSweden,
    [httpsEnSeStagingPawshakeIo]: EnglishSweden,
    [httpsEnChStagingPawshakeIo]: EnglishSwitzerland,
    [httpsEnUsStagingPawshakeIo]: EnglishUnitedStates,
    [httpsWwwPawshakeCom]: EnglishUnitedStates,
    [httpsEnBePawshakeMe]: EnglishBelgium,
    [httpsNlBePawshakeMe]: DutchBelgium,
    [httpsFrBePawshakeMe]: FrenchBelgium,
    [httpsDeBePawshakeMe]: GermanBelgium,
    [httpsDeChPawshakeMe]: GermanSwitzerland,
    [httpsFrChPawshakeMe]: FrenchSwitzerland,
    [httpsItChPawshakeMe]: ItalianSwitzerland,
    [httpsEnLuPawshakeMe]: EnglishLuxembourg,
    [httpsDeLuPawshakeMe]: GermanLuxembourg,
    [httpsFrLuPawshakeMe]: FrenchLuxembourg,
    [httpsEnCaPawshakeMe]: EnglishCanada,
    [httpsFrCaPawshakeMe]: FrenchCanada,
    [httpsEnDePawshakeMe]: EnglishGermany,
    [httpsDeDePawshakeMe]: GermanGermany,
    [httpsEnFrPawshakeMe]: EnglishFrance,
    [httpsFrFrPawshakeMe]: FrenchFrance,
    [httpsEnNlPawshakeMe]: EnglishNetherlands,
    [httpsNlNlPawshakeMe]: DutchNetherlands,
    [httpsDeAtPawshakeMe]: GermanAustria,
    [httpsEnAtPawshakeMe]: EnglishAustria,
    [httpsEnNzPawshakeMe]: EnglishNewZealand,
    [httpsEnGbPawshakeMe]: EnglishGreatBritain,
    [httpsEnAuPawshakeMe]: EnglishAustralia,
    [httpsEnHkPawshakeMe]: EnglishHongKong,
    [httpsEnSgPawshakeMe]: EnglishSingapore,
    [httpsDaDkPawshakeMe]: DanishDenmark,
    [httpsEnDkPawshakeMe]: EnglishDenmark,
    [httpsFiFiPawshakeMe]: FinnishFinland,
    [httpsEnFiPawshakeMe]: EnglishFinland,
    [httpsEnIePawshakeMe]: EnglishIreland,
    [httpsItItPawshakeMe]: ItalianItaly,
    [httpsEnItPawshakeMe]: EnglishItaly,
    [httpsEnJpPawshakeMe]: EnglishJapan,
    [httpsNoNoPawshakeMe]: NorwegianNorway,
    [httpsEnNoPawshakeMe]: EnglishNorway,
    [httpsSvSePawshakeMe]: SwedishSweden,
    [httpsEnSePawshakeMe]: EnglishSweden,
    [httpsEnChPawshakeMe]: EnglishSwitzerland,
    [httpsEnUsPawshakeMe]: EnglishUnitedStates,
    'https://de.pawshake.ch': GermanSwitzerland,
    'https://fr.pawshake.ch': FrenchSwitzerland,
    'https://it.pawshake.ch': ItalianSwitzerland,
    'https://de.pawshake.lu': GermanLuxembourg,
    'https://fr.pawshake.lu': FrenchLuxembourg,
    'https://en.pawshake.lu': EnglishLuxembourg,
    'https://fr.pawshake.ca': FrenchCanada,
    'https://en.pawshake.ca': EnglishCanada,
    'https://en.pawshake.de': EnglishGermany,
    'https://en.pawshake.fr': EnglishFrance,
    'https://www.pawshake.fr': FrenchFrance,
    'https://en.pawshake.nl': EnglishNetherlands,
    'https://www.pawshake.nl': DutchNetherlands,
    'https://www.pawshake.at': GermanAustria,
    'https://en.pawshake.at': EnglishAustria,
    'https://www.pawshake.co.nz': EnglishNewZealand,
    'https://www.pawshake.co.uk': EnglishGreatBritain,
    'https://www.pawshake.com.au': EnglishAustralia,
    'https://www.pawshake.com.hk': EnglishHongKong,
    'https://www.pawshake.com.sg': EnglishSingapore,
    'https://www.pawshake.de': GermanGermany,
    'https://www.pawshake.dk': DanishDenmark,
    'https://en.pawshake.dk': EnglishDenmark,
    'https://www.pawshake.fi': FinnishFinland,
    'https://en.pawshake.fi': EnglishFinland,
    'https://www.pawshake.ie': EnglishIreland,
    'https://www.pawshake.it': ItalianItaly,
    'https://en.pawshake.it': EnglishItaly,
    'https://www.pawshake.jp': EnglishJapan,
    'https://www.pawshake.no': NorwegianNorway,
    'https://en.pawshake.no': EnglishNorway,
    'https://www.pawshake.se': SwedishSweden,
    'https://en.pawshake.se': EnglishSweden,
    'https://en.pawshake.ch': EnglishSwitzerland,
};

const cloudfrontRegions = {
    'en-BE': httpsEnPawshakeBe,
    'de-BE': httpsDePawshakeBe,
    'fr-BE': httpsFrPawshakeBe,
    'nl-BE': httpsNlPawshakeBe,
    'de-CH': httpsDePawshakeCh,
    'fr-CH': httpsFrPawshakeCh,
    'it-CH': httpsItPawshakeCh,
    'de-LU': httpsDePawshakeLu,
    'fr-LU': httpsFrPawshakeLu,
    'en-LU': httpsEnPawshakeLu,
    'fr-CA': httpsFrPawshakeCa,
    'en-CA': httpsEnPawshakeCa,
    'en-DE': httpsEnPawshakeDe,
    'en-FR': httpsEnPawshakeFr,
    'fr-FR': httpsWwwPawshakeFr,
    'en-NL': httpsEnPawshakeNl,
    'nl-NL': httpsWwwPawshakeNl,
    'de-AT': httpsWwwPawshakeAt,
    'en-AT': httpsEnPawshakeAt,
    'en-NZ': httpsWwwPawshakeCoNz,
    'en-GB': httpsWwwPawshakeCoUk,
    'en-AU': httpsWwwPawshakeComAu,
    'en-HK': httpsWwwPawshakeComHk,
    'en-SG': httpsWwwPawshakeComSg,
    'de-DE': httpsWwwPawshakeDe,
    'da-DK': httpsWwwPawshakeDk,
    'en-DK': httpsEnPawshakeDk,
    'fi-FI': httpsWwwPawshakeFi,
    'en-FI': httpsEnPawshakeFi,
    'en-IE': httpsWwwPawshakeIe,
    'it-IT': httpsWwwPawshakeIt,
    'en-IT': httpsEnPawshakeIt,
    'en-JP': httpsWwwPawshakeJp,
    'no-NO': httpsWwwPawshakeNo,
    'en-NO': httpsEnPawshakeNo,
    'sv-SE': httpsWwwPawshakeSe,
    'en-SE': httpsEnPawshakeSe,
    'en-CH': httpsEnPawshakeCh,
    'en-US': httpsWwwPawshakeCom,
};

const getDomainBasedUponLocale = (locale) => {
    return cloudfrontRegions[locale.toString()];
};

const getDomainBasedUponCloudfrontRegion = (cloudFrontRegion) => {
    if (cloudfrontRegions.hasOwnProperty(cloudFrontRegion)) {
        return cloudfrontRegions[cloudFrontRegion];
    }
    return httpsEnPawshakeBe;
};

const getLocalBrandNameOf = (domain) => {
    if (localBrandNames.hasOwnProperty(domain)) {
        return localBrandNames[domain];
    }
    return 'Pawshake';
};

const getLocaleOf = (domain) => {
    if (locales.hasOwnProperty(domain)) {
        return locales[domain];
    }
    return EnglishBelgium;
};

const getCountryOf = (domain) => {
    const localeOf = getLocaleOf(domain);
    return localeOf.getCountry();
};

const getDefaultIndexableSearchableService = (domain) => {
    if (domain === httpsWwwPawshakeComHk) {
        return petSittingService;
    }

    if (domain === httpsWwwPawshakeIt) {
        return dogSittingService;
    }

    if (
        [httpsFrPawshakeCa, httpsFrPawshakeLu, httpsFrPawshakeBe, httpsFrPawshakeCh, httpsWwwPawshakeFr].includes(
            domain
        )
    ) {
        return doggyDayCareService;
    }

    return homeDogBoardingService;
};

const Locales = [
    EnglishBelgium,
    GermanBelgium,
    FrenchBelgium,
    DutchBelgium,
    GermanSwitzerland,
    FrenchSwitzerland,
    ItalianSwitzerland,
    EnglishSwitzerland,
    GermanLuxembourg,
    FrenchLuxembourg,
    EnglishLuxembourg,
    FrenchCanada,
    EnglishCanada,
    EnglishGermany,
    EnglishFrance,
    FrenchFrance,
    EnglishNetherlands,
    DutchNetherlands,
    GermanAustria,
    EnglishAustria,
    EnglishNewZealand,
    EnglishGreatBritain,
    EnglishAustralia,
    EnglishHongKong,
    EnglishSingapore,
    GermanGermany,
    DanishDenmark,
    EnglishDenmark,
    FinnishFinland,
    EnglishFinland,
    EnglishIreland,
    ItalianItaly,
    EnglishItaly,
    EnglishJapan,
    NorwegianNorway,
    EnglishNorway,
    SwedishSweden,
    EnglishSweden,
    EnglishUnitedStates,
];

const Domains = [
    httpsWwwPawshakeComAu,
    httpsWwwPawshakeAt,
    httpsEnPawshakeAt,
    httpsDePawshakeBe,
    httpsEnPawshakeBe,
    httpsFrPawshakeBe,
    httpsNlPawshakeBe,
    httpsEnBeStagingPawshakeIo,
    httpsNlBeStagingPawshakeIo,
    httpsFrBeStagingPawshakeIo,
    httpsDeBeStagingPawshakeIo,
    httpsDeChStagingPawshakeIo,
    httpsFrChStagingPawshakeIo,
    httpsItChStagingPawshakeIo,
    httpsEnChStagingPawshakeIo,
    httpsEnLuStagingPawshakeIo,
    httpsDeLuStagingPawshakeIo,
    httpsFrLuStagingPawshakeIo,
    httpsEnCaStagingPawshakeIo,
    httpsFrCaStagingPawshakeIo,
    httpsEnDeStagingPawshakeIo,
    httpsDeDeStagingPawshakeIo,
    httpsEnFrStagingPawshakeIo,
    httpsFrFrStagingPawshakeIo,
    httpsEnNlStagingPawshakeIo,
    httpsNlNlStagingPawshakeIo,
    httpsDeAtStagingPawshakeIo,
    httpsEnAtStagingPawshakeIo,
    httpsEnNzStagingPawshakeIo,
    httpsEnGbStagingPawshakeIo,
    httpsEnAuStagingPawshakeIo,
    httpsEnHkStagingPawshakeIo,
    httpsEnSgStagingPawshakeIo,
    httpsDaDkStagingPawshakeIo,
    httpsEnDkStagingPawshakeIo,
    httpsFiFiStagingPawshakeIo,
    httpsEnFiStagingPawshakeIo,
    httpsEnIeStagingPawshakeIo,
    httpsItItStagingPawshakeIo,
    httpsEnItStagingPawshakeIo,
    httpsEnJpStagingPawshakeIo,
    httpsNoNoStagingPawshakeIo,
    httpsEnNoStagingPawshakeIo,
    httpsSvSeStagingPawshakeIo,
    httpsEnSeStagingPawshakeIo,
    httpsEnUsStagingPawshakeIo,
    httpsEnBePawshakeMe,
    httpsNlBePawshakeMe,
    httpsFrBePawshakeMe,
    httpsDeBePawshakeMe,
    httpsEnCaPawshakeMe,
    httpsFrCaPawshakeMe,
    httpsDeChPawshakeMe,
    httpsFrChPawshakeMe,
    httpsItChPawshakeMe,
    httpsEnChPawshakeMe,
    httpsEnLuPawshakeMe,
    httpsDeLuPawshakeMe,
    httpsFrLuPawshakeMe,
    httpsEnDePawshakeMe,
    httpsDeDePawshakeMe,
    httpsEnFrPawshakeMe,
    httpsFrFrPawshakeMe,
    httpsEnNlPawshakeMe,
    httpsNlNlPawshakeMe,
    httpsDeAtPawshakeMe,
    httpsEnAtPawshakeMe,
    httpsEnNzPawshakeMe,
    httpsEnGbPawshakeMe,
    httpsEnAuPawshakeMe,
    httpsEnHkPawshakeMe,
    httpsEnSgPawshakeMe,
    httpsDaDkPawshakeMe,
    httpsEnDkPawshakeMe,
    httpsFiFiPawshakeMe,
    httpsEnFiPawshakeMe,
    httpsEnIePawshakeMe,
    httpsItItPawshakeMe,
    httpsEnItPawshakeMe,
    httpsEnJpPawshakeMe,
    httpsNoNoPawshakeMe,
    httpsEnNoPawshakeMe,
    httpsSvSePawshakeMe,
    httpsEnSePawshakeMe,
    httpsEnUsPawshakeMe,
    httpsEnPawshakeCa,
    httpsFrPawshakeCa,
    httpsWwwPawshakeDk,
    httpsEnPawshakeDk,
    httpsWwwPawshakeFi,
    httpsEnPawshakeFi,
    httpsEnPawshakeFr,
    httpsWwwPawshakeFr,
    httpsWwwPawshakeDe,
    httpsEnPawshakeDe,
    httpsWwwPawshakeComHk,
    httpsWwwPawshakeIe,
    httpsWwwPawshakeIt,
    httpsEnPawshakeIt,
    httpsWwwPawshakeJp,
    httpsDePawshakeLu,
    httpsEnPawshakeLu,
    httpsFrPawshakeLu,
    httpsWwwPawshakeCoNz,
    httpsWwwPawshakeNo,
    httpsEnPawshakeNo,
    httpsWwwPawshakeComSg,
    httpsWwwPawshakeSe,
    httpsEnPawshakeSe,
    httpsDePawshakeCh,
    httpsItPawshakeCh,
    httpsFrPawshakeCh,
    httpsEnPawshakeCh,
    httpsEnPawshakeNl,
    httpsWwwPawshakeNl,
    httpsWwwPawshakeCoUk,
    httpsWwwPawshakeCom,
];

module.exports = {
    httpsEnPawshakeBe,
    httpsDePawshakeBe,
    httpsNlPawshakeBe,
    httpsFrPawshakeBe,
    httpsEnBeStagingPawshakeIo,
    httpsNlBeStagingPawshakeIo,
    httpsFrBeStagingPawshakeIo,
    httpsDeBeStagingPawshakeIo,
    httpsDeChStagingPawshakeIo,
    httpsFrChStagingPawshakeIo,
    httpsItChStagingPawshakeIo,
    httpsEnChStagingPawshakeIo,
    httpsEnLuStagingPawshakeIo,
    httpsDeLuStagingPawshakeIo,
    httpsFrLuStagingPawshakeIo,
    httpsEnCaStagingPawshakeIo,
    httpsFrCaStagingPawshakeIo,
    httpsEnDeStagingPawshakeIo,
    httpsDeDeStagingPawshakeIo,
    httpsEnFrStagingPawshakeIo,
    httpsFrFrStagingPawshakeIo,
    httpsEnNlStagingPawshakeIo,
    httpsNlNlStagingPawshakeIo,
    httpsDeAtStagingPawshakeIo,
    httpsEnAtStagingPawshakeIo,
    httpsEnNzStagingPawshakeIo,
    httpsEnGbStagingPawshakeIo,
    httpsEnAuStagingPawshakeIo,
    httpsEnHkStagingPawshakeIo,
    httpsEnSgStagingPawshakeIo,
    httpsDaDkStagingPawshakeIo,
    httpsEnDkStagingPawshakeIo,
    httpsFiFiStagingPawshakeIo,
    httpsEnFiStagingPawshakeIo,
    httpsEnIeStagingPawshakeIo,
    httpsItItStagingPawshakeIo,
    httpsEnItStagingPawshakeIo,
    httpsEnJpStagingPawshakeIo,
    httpsNoNoStagingPawshakeIo,
    httpsEnNoStagingPawshakeIo,
    httpsSvSeStagingPawshakeIo,
    httpsEnSeStagingPawshakeIo,
    httpsEnUsStagingPawshakeIo,
    httpsEnBePawshakeMe,
    httpsNlBePawshakeMe,
    httpsFrBePawshakeMe,
    httpsDeBePawshakeMe,
    httpsEnCaPawshakeMe,
    httpsFrCaPawshakeMe,
    httpsDeChPawshakeMe,
    httpsFrChPawshakeMe,
    httpsItChPawshakeMe,
    httpsEnChPawshakeMe,
    httpsEnLuPawshakeMe,
    httpsDeLuPawshakeMe,
    httpsFrLuPawshakeMe,
    httpsEnDePawshakeMe,
    httpsDeDePawshakeMe,
    httpsEnFrPawshakeMe,
    httpsFrFrPawshakeMe,
    httpsEnNlPawshakeMe,
    httpsNlNlPawshakeMe,
    httpsDeAtPawshakeMe,
    httpsEnAtPawshakeMe,
    httpsEnNzPawshakeMe,
    httpsEnGbPawshakeMe,
    httpsEnAuPawshakeMe,
    httpsEnHkPawshakeMe,
    httpsEnSgPawshakeMe,
    httpsDaDkPawshakeMe,
    httpsEnDkPawshakeMe,
    httpsFiFiPawshakeMe,
    httpsEnFiPawshakeMe,
    httpsEnIePawshakeMe,
    httpsItItPawshakeMe,
    httpsEnItPawshakeMe,
    httpsEnJpPawshakeMe,
    httpsNoNoPawshakeMe,
    httpsEnNoPawshakeMe,
    httpsSvSePawshakeMe,
    httpsEnSePawshakeMe,
    httpsEnUsPawshakeMe,
    httpsEnPawshakeCa,
    httpsFrPawshakeCa,
    httpsDePawshakeCh,
    httpsFrPawshakeCh,
    httpsItPawshakeCh,
    httpsEnPawshakeCh,
    httpsEnPawshakeLu,
    httpsDePawshakeLu,
    httpsFrPawshakeLu,
    httpsEnPawshakeDe,
    httpsWwwPawshakeDe,
    httpsEnPawshakeFr,
    httpsWwwPawshakeFr,
    httpsEnPawshakeNl,
    httpsWwwPawshakeNl,
    httpsWwwPawshakeAt,
    httpsEnPawshakeAt,
    httpsWwwPawshakeCoNz,
    httpsWwwPawshakeCoUk,
    httpsWwwPawshakeCom,
    httpsWwwPawshakeComAu,
    httpsWwwPawshakeComHk,
    httpsWwwPawshakeComSg,
    httpsWwwPawshakeDk,
    httpsEnPawshakeDk,
    httpsWwwPawshakeFi,
    httpsEnPawshakeFi,
    httpsWwwPawshakeIe,
    httpsWwwPawshakeIt,
    httpsEnPawshakeIt,
    httpsWwwPawshakeJp,
    httpsWwwPawshakeNo,
    httpsEnPawshakeNo,
    httpsWwwPawshakeSe,
    httpsEnPawshakeSe,
    Domains,
    Locales,

    getLocalBrandNameOf,
    getLocaleOf,
    getCountryOf,
    getDomainBasedUponCloudfrontRegion,
    getDomainBasedUponLocale,
    getDefaultIndexableSearchableService,
};
